var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 81,
    viewBox: "0 0 27 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89443 77.7779L13.955 43.6513M13.955 43.6513L22.4399 78.4392M13.955 43.6513V20.7422M2.50049 44.4998L5.89443 37.7119L13.955 20.7422L21.5914 37.7119L24.1369 43.6513",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43994 7.59077C8.43994 8.94097 8.9763 10.2359 9.93103 11.1906C10.8858 12.1453 12.1807 12.6817 13.5309 12.6817C14.881 12.6817 16.1759 12.1453 17.1307 11.1906C18.0854 10.2359 18.6218 8.94097 18.6218 7.59077C18.6218 6.24058 18.0854 4.94569 17.1307 3.99096C16.1759 3.03623 14.881 2.49986 13.5309 2.49986C12.1807 2.49986 10.8858 3.03623 9.93103 3.99096C8.9763 4.94569 8.43994 6.24058 8.43994 7.59077Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup84);
export default __webpack_public_path__ + "static/media/Group 84.419fcedfdc4c492e8e2448f9be95c688.svg";
export { ForwardRef as ReactComponent };